import React, { useState, useEffect } from "react";
import styles from "./StockExchange.module.scss";
import "react-datepicker/dist/react-datepicker.css";
import stockExchangeBanner from "../../assets/images/stockExchangeBanner.png";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import { Icon } from "../../assets/Icons.tsx";
import { investorStockAndExchangeData } from "../../redux/slices/investorSlice.js";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";


const StockExchange: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Investors", link: "/investors" },
    { title: "Filings with Stock Exchanges", link: "/filings-with-stock-exchanges" },
  ];
  return (
    <div className={`${styles.StockExchange} section`}>
      <BreadCrumb menu={breadcrumb} />
      <motion.div
  initial={{ opacity: 0, y: 100 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
  transition={{ duration: 1, ease: "easeInOut" }}
  >
      <Banner />
      <DataTable />
      </motion.div>
    </div>
  );
};

export default StockExchange;

const Banner: React.FC = () => {
  return (
    <div className="container ">
      <div className="row mt-lg-5 mt-md-4 mt-5">
        <div className="col-lg-6 col-md-12 d-flex flex-column justify-content-center">
          <p className="heading">Filings with Stock Exchanges</p>
          <p className="para pt-3">
            Aptech ensures timely and accurate communication with stock
            exchanges to keep investors and stakeholders informed about the
            company’s important developments. This page provides access to the
            regulatory filings submitted to stock exchanges.  
          </p>
        </div>
        <div className="col-lg-6 col-md-12 d-flex justify-content-center">
          <img
            src={stockExchangeBanner}
            alt="stockExchangeBanner"
            className="img-fluid"
          />
        </div>
      </div>
    </div>
  );
};

const DataTable: React.FC = () => {
  const downloadFile = async (fileUrl, fileName) => {
    const url = fileUrl;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch the PDF file.");
      }
      const blob = await response.blob();
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };
  const dispatch = useDispatch();

  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [yearRange, setYearRange] = useState([
    new Date().getFullYear(),
    new Date().getFullYear() - 4,
  ]);
  const [activeTab, setActiveTab] = useState(yearRange[0]);

  const handleNext = () => {
    setYearRange((prev) => [prev[0] - 5, prev[1] - 5]);

    console.log(yearRange, "yearRange555");
    setActiveTab(yearRange[1] - 1);
  };

  const handlePrevious = () => {
    setYearRange((prev) => [prev[0] + 5, prev[1] + 5]);
    console.log(yearRange, "llll");
    setActiveTab(yearRange[0] + 5);
  };

  const handleTabClick = (year) => {
    setActiveTab(year);
    setSelectedYear(year);
  };

  const [filteredNews, setFilteredNews] = useState([]);
  const [filteredCards, setFilteredCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const startYear = 2015;
  const endYear = new Date().getFullYear();
  const years = [];

  for (let year = endYear; year >= startYear; year--) {
    years.push(`${year}`);
  }

  useEffect(() => {
    const fetchStockAndExchangeData = async () => {
      setLoading(true);
      try {
        const data = await dispatch(investorStockAndExchangeData()).unwrap();
        console.log(data, "stockdata");
        setFilteredNews(data?.stock_results || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching investor overview data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchStockAndExchangeData();
  }, [dispatch]);

  useEffect(() => {
    const filterData = () => {
      if (activeTab) {
        setSelectedYear(activeTab);
      }
      const filteredYearData = filteredNews?.find(
        (item) => item?.year?.toString() === selectedYear.toString()
      );
      console.log(filteredYearData, "klll");

      let filteredFiles = filteredYearData?.files || [];

      console.log(filteredFiles, "filteredFiles");
      setFilteredCards(filteredFiles);
    };

    filterData();
  }, [selectedYear, filteredNews, yearRange, activeTab]);

  const nextDisabled = yearRange[1] > 2015 ? false : true;

  return (
    <div className="container-fluid">
      <div className={`${styles.DataTable} section`}>
        <>
          <div className="row mb-lg-5 mb-md-5 mb-0 mt-lg-5 mt-md-3 mt-3 g-0">
            <div className="col-lg-12 col-md-12">
              <div className="container">
                <div className={`${styles.filters}`}>
                  <div
                    className={`${styles.year} d-flex justify-content-center align-items-center`}
                  >
                    <button
                      onClick={handlePrevious}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "white",
                      }}
                      disabled={yearRange[0] >= new Date().getFullYear()}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <Icon
                        name="dropdownLeftArrow"
                        color="white"
                        width="25px"
                        height="25px"
                      />
                    </button>
                    <span
                      className="d-flex justify-content-center align-items-center"
                      style={{ fontSize: "24px" }}
                    >
                      <Icon name="calender" color="white" />
                    </span>
                    <span className=" mb-0">&nbsp;Year |&nbsp;</span>

                    <div className={styles.customSelect}>
                      <div className={` mb-0 ${styles.textPadding}`}>
                        <span
                          className="text-center"
                          style={{ color: "white" }}
                        >
                          {yearRange[1] !== ""
                            ? `${yearRange[0]} - ${yearRange[1]}`
                            : yearRange[0]}
                        </span>
                      </div>
                    </div>
                    <button
                      onClick={handleNext}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "white",
                      }}
                      disabled={nextDisabled}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <Icon
                        name="dropdownRightArrow"
                        color="white"
                        width="25px"
                        height="25px"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <ul
                className={`nav nav-pills ${styles.navPills} d-flex overflow-auto`}
                id="pills-tab"
                role="tablist"
                style={{ whiteSpace: "nowrap" }}
              >
                {Array.from(
                  { length: yearRange[0] - yearRange[1] + 1 },
                  (_, i) => yearRange[0] - i
                )
                  // .filter((year) => year >= 2015) // Only include years >= 2015
                  .map((year) => (
                    <li
                      key={year}
                      className="nav-item flex-shrink-0"
                      role="presentation"
                    >
                      <button
                        className={`para mb-0 ${styles.navLink} ${
                          activeTab === year ? styles.navLinkActive : ""
                        }`}
                        onClick={() => handleTabClick(year)}
                        type="button"
                        role="tab"
                        aria-controls={`pills-${year}`}
                        aria-selected={activeTab === year}
                      >
                        {year}
                      </button>
                    </li>
                  ))}
              </ul>
            </div>
          </div>

          {!loading ? (
            <div className="container">
              <div className={`row g-0 ${styles.header}`}>
                <div className="col-lg-10 col-md-8 col-sm-12 d-flex justify-content-start align-items-center">
                  <p className="para caps fw-bold mb-0 ">title</p>
                </div>
                <div className="col-lg-1 col-md-2 col-sm-0 d-flex justify-content-center align-items-center">
                  <p className={`${styles.view} para fw-bold mb-0 p-2 caps`}>
                    View
                  </p>{" "}
                </div>
                <div className="col-lg-1 col-md-2 col-sm-0 d-flex justify-content-center align-items-center">
                  <p
                    className={`${styles.download} para fw-bold mb-0 p-2 caps`}
                  >
                    Download
                  </p>{" "}
                </div>
              </div>
              <div className="mb-3">
                {filteredCards?.map((card, index) => (
                  <div
                    className={`row g-0 ${styles.brandCard} mt-2 align-items-stretch`}
                    key={index}
                  >
                    <div className="col-lg-10 col-md-8 col-sm-8 col-8 d-flex justify-content-start align-items-center">
                      <div className="d-flex justify-content-center align-items-center">
                        <div style={{ width: "25px" }} className="">
                          <Icon name="pdfIcon" width="25px" />
                        </div>
                        <div>
                          <p className={`para mb-0 ${styles.titleStyle}`}>
                            {card?.title}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-2 col-2 d-flex justify-content-center align-items-center">
                      <div style={{ cursor: "pointer" }}>
                        <a
                          href={card?.document_path}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Icon
                            name="eyeIcon"
                            color="#036995"
                            height="35px"
                            width="35px"
                          />
                        </a>
                      </div>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-2 col-2 d-flex justify-content-center align-items-center">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          downloadFile(card?.document_path, card?.title)
                        }
                      >
                        <Icon
                          name="circleDownArrow"
                          color="#036995"
                          height="35px"
                          width="35px"
                        />
                      </span>
                    </div>
                  </div>
                ))}
                {filteredCards?.length === 0 && (
                  <div className={`${styles.brandCard} p-0 mt-2`}>
                    <p className="subHeading text-center caps mt-4 mb-4">
                      No Data available
                    </p>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <p className="para text-center">Loading...</p>
          )}
        </>
      </div>
    </div>
  );
};
